import { render } from "./GamePop1.vue?vue&type=template&id=8fa86208"
import script from "./GamePop1.vue?vue&type=script&lang=js"
export * from "./GamePop1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__